import {
  Building2,
  ShoppingCart,
  HeartPulse,
  CreditCard,
  Rocket,
  LayoutGrid,
} from "lucide-react";

import TechSectionHeader from "./TechSectionHeader";
import "./tech-industries.css";

const industries = [
  {
    title: "SaaS Platforms",
    icon: LayoutGrid,
    desc: "Scalable cloud-native platforms built for growth and performance.",
  },
  {
    title: "Startups",
    icon: Rocket,
    desc: "Fast MVPs, product-market fit validation, and growth-ready systems.",
  },
  {
    title: "E-Commerce",
    icon: ShoppingCart,
    desc: "High-conversion storefronts with secure payments and automation.",
  },
  {
    title: "Fintech",
    icon: CreditCard,
    desc: "Secure, compliant financial solutions with robust architecture.",
  },
  {
    title: "Healthcare",
    icon: HeartPulse,
    desc: "HIPAA-ready platforms with privacy-first data handling.",
  },
  {
    title: "Real Estate",
    icon: Building2,
    desc: "Digital platforms for listings, CRM, analytics, and automation.",
  },
];

export default function TechIndustries() {
  return (
    <section className="oglitz-tech-industries">
      <div className="oglitz-tech-industries__container">
        <TechSectionHeader
          title="Industries We"
          highlight="Serve"
          subtitle="Technology solutions crafted for diverse industries and complex business needs."
        />

        <div className="oglitz-tech-industries__grid">
          {industries.map((item, index) => (
            <div key={index} className="oglitz-tech-industries__card">
              <item.icon />
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
